import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { AlertTriangle, AlertCircle } from 'lucide-react';
import { LevelBadge, ProgressBadge, alertIcons, alertColors, alertBg, formatAlertMessage } from './StudentBadges';

export const SummaryCards = ({ cards }) => (
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3" data-testid="student-summary-cards">
        {cards.map(c => (
          <Card key={c.id} className="bg-card border-border" data-testid={`student-card-${c.id}`}>
            <CardContent className="p-4">
              <p className="text-xs text-muted-foreground mb-1">{c.label}</p>
              {c.type === 'level' ? <LevelBadge value={c.value} size="lg" />
                : c.type === 'progress' ? <ProgressBadge value={c.value} className="text-2xl" />
                : <p className={`text-2xl font-black ${c.color || ''}`}>{c.value ?? '—'}</p>}
              {c.sub && <p className="text-xs text-muted-foreground mt-1">{c.sub}</p>}
            </CardContent>
          </Card>
        ))}
      </div>
);

export const AlertsCard = ({ alerts }) => (
  alerts?.length > 0 && (
        <Card className="bg-card border-border" data-testid="student-alerts">
          <CardHeader className="pb-2">
            <CardTitle className="text-base flex items-center gap-2"><AlertTriangle className="w-4 h-4 text-amber-400" /> Alertes ({alerts.length})</CardTitle>
          </CardHeader>
          <CardContent className="space-y-2">
            {alerts.map((a, i) => {
              const Icon = alertIcons[a.type] || AlertCircle;
              return (
                <div key={`alert-${a.type}-${i}`} className={`flex items-start gap-3 p-3 rounded-lg border ${alertBg[a.type] || 'bg-muted/30 border-border'}`} data-testid={`student-alert-${i}`}>
                  <Icon className={`w-4 h-4 mt-0.5 shrink-0 ${alertColors[a.type] || 'text-muted-foreground'}`} />
                  <p className="text-sm">{formatAlertMessage(a)}</p>
                </div>
              );
            })}
          </CardContent>
        </Card>
  )
);
